import { Formie } from '../../../vendor/verbb/formie/src/web/assets/frontend/src/js/formie-lib'

export const initForms = () => {
  
  const forms = document.querySelectorAll('.fui-form')

  if (!forms) return

  const FormieInstance = new Formie()

  forms.forEach(form => FormieInstance.initForm(form))

  document.addEventListener('onFormieInit', (e) => {

    let Test = e.detail.formie

    console.log(Test)

  })

}

export default () => {}